import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MyStyles.css';

import {baseUrl, userLocation, ipAddress, userName} from './Univ.js'
function Menu(){
    const userGroup= localStorage.getItem('userGroup');
    return (
        <section >
              <div className="row ">
              {userGroup === 'Admin' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/" data-toggle="tooltip" title="Dashboard">
                <FontAwesomeIcon icon="fa-solid fa-chart-line" size="4x" className="mx-auto d-block"color="#2194d9" />
                <p className="fw-bold pt-2 text-center">Dashboard</p></a>
                </div>
                </div>
                </div>
              ) : null}

            {userGroup === 'Admin' || userGroup === 'Accounting' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/account-menu/" data-toggle="tooltip" title="Bank"><FontAwesomeIcon icon="fa-solid fa-file-invoice-dollar " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center"> Accounting</p></a>
                </div>
                </div>
                </div>
              ) : null}
              {/* Manufacturing */}
                {userGroup === 'Admin' || userGroup === 'Management' ? (
                  <div className="col-sm-2 me-4">
                    <div className="card shadow mt-4" id="my-card">
                      <div className="card-body">
                        <a href="/manufacturing-menu" data-toggle="tooltip" title="Manufacturing">
                          <FontAwesomeIcon
                            icon="fa-solid fa-industry"
                            size="4x"
                            className="mx-auto d-block"
                            color="#2194d9"
                          />
                          <p className="fw-bold pt-2 text-center">Manufacturing</p>
                        </a>
                      </div>
                    </div>
                  </div>
                ) : null}

              {userGroup === 'Admin' || userGroup === 'Stores' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/stores-menu/" data-toggle="tooltip" title="Store"><FontAwesomeIcon icon="fa fa-store" size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">Warehouse</p></a>
                </div>
                </div>
                </div>
              ) : null}

	      {userGroup === 'Admin' || userGroup === 'Crm' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a  href="/crm-menu/" data-toggle="tooltip" title="Crm"><FontAwesomeIcon icon="fa fa-id-badge " size="4x" className="mx-auto d-block" color="#2194d9" /><p className="fw-bold pt-2 text-center">CRM</p></a>
                </div>
                </div>
                </div>
              ) : null}

              {userGroup === 'Admin'|| userGroup === 'Hr' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/hrms-menu/" data-toggle="tooltip" title="HRMS"><FontAwesomeIcon icon="fa-solid fa-people-line"  size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">HRMS</p></a>
                </div>
                </div>
                </div>
              ) : null}

              {userGroup === 'Admin' || userGroup === 'Stores' || userGroup === 'Management' || userGroup === 'Accounting' || userGroup === 'Crm' ? (
                <>
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/ticket-menu/" data-toggle="tooltip" title="Ticketing"><FontAwesomeIcon icon="fa fa-ticket " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">Ticketing</p></a>
                </div>
                </div>
                </div>

                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/comp-mess/" data-toggle="tooltip" title="Messaging"><FontAwesomeIcon icon="fa fa-comment-sms " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">Messaging</p></a>
                </div>
                </div>
                </div>
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/events" data-toggle="tooltip" title="Events"><FontAwesomeIcon icon="fa-regular fa-calendar-days " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">Events List</p></a>
                </div>
                </div>
                </div>
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/todolist" data-toggle="tooltip" title="ToDoList"><FontAwesomeIcon icon="fa-solid fa-tasks " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">To-Do Lists List</p></a>
                </div>
                </div>
                </div>
    	        <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/support/" data-toggle="tooltip" title="Support"><FontAwesomeIcon icon="fa fa-wrench " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">MGM Support</p></a>
                </div>
                </div>
                </div>

		</>
                ) : null}
              {userGroup === 'Admin' ? (
                <div className="col-sm-2 me-4">
                <div className="card shadow mt-4" id="my-card">
                <div className="card-body">
                <a href="/news/" data-toggle="tooltip" title="News&Events"><FontAwesomeIcon icon="fa-regular fa-newspaper " size="4x" className="mx-auto d-block"color="#2194d9" /><p className="fw-bold pt-2 text-center">News & Events</p></a>
                </div>
                </div>
                </div>
              ) : null}

             </div>
        </section>
    )
}

export default Menu;
